import request from '@/utils/request'

// 加载大宗原料行情申请信息
export function selectInfoById(id) {
  return request({
    url: `/api/srm-slcm/pmCommodityQuotationApply/selectInfoById/${id}`,
    method: 'get'
  })
}
